import { render, staticRenderFns } from "./load-more-loader.vue?vue&type=template&id=32e9d0aa"
import script from "./load-more-loader.vue?vue&type=script&lang=js"
export * from "./load-more-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports